<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show.sync="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'md'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <!-- Contexto del medicamento -->
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="alert alert-light border mb-0 py-2 px-3 small">
          <div>
            <strong>Marca:</strong> {{ item.brand || "-" }}
          </div>
          <div>
            <strong>Molécula:</strong> {{ item.molecule || "-" }}
          </div>
          <div>
            <strong>Presentación:</strong> {{ item.presentation || "-" }}
          </div>
        </div>
      </div>
    </div>

    <!-- Radios -->
    <div class="row">
      <div class="col-md-12 mb-3">
        <label class="form-label fw-bold">¿Es psicotrópico?</label>
      </div>

      <!-- Sí -->
      <div class="col-md-6 mb-2">
        <div
          class="card p-3 text-center"
          :class="
            localValue === 1
              ? 'border-danger bg-light shadow-sm'
              : 'border-secondary-subtle'
          "
          style="cursor: pointer; transition: all 0.2s"
          @click="localValue = 1"
        >
          <div class="form-check d-flex justify-content-center mb-2">
            <input
              class="form-check-input"
              type="radio"
              name="psico"
              :value="1"
              v-model.number="localValue"
            />
          </div>
          <i
            class="fas fa-pills"
            :class="localValue === 1 ? 'text-danger' : 'text-secondary'"
            style="font-size: 2rem"
          ></i>
          <div class="mt-2 fw-bold">Sí es psicotrópico</div>
        </div>
      </div>

      <!-- No -->
      <div class="col-md-6 mb-2">
        <div
          class="card p-3 text-center"
          :class="
            localValue === 0
              ? 'border-success bg-light shadow-sm'
              : 'border-secondary-subtle'
          "
          style="cursor: pointer; transition: all 0.2s"
          @click="localValue = 0"
        >
          <div class="form-check d-flex justify-content-center mb-2">
            <input
              class="form-check-input"
              type="radio"
              name="psico"
              :value="0"
              v-model.number="localValue"
            />
          </div>
          <i
            class="fas fa-check-circle"
            :class="localValue === 0 ? 'text-success' : 'text-secondary'"
            style="font-size: 2rem"
          ></i>
          <div class="mt-2 fw-bold">No es psicotrópico</div>
        </div>
      </div>
    </div>

    <template #footer>
      <button @click="mtdClose" class="btn btn-danger btn-sm">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      &nbsp;
      <button class="btn btn-success btn-sm" @click="mtdSave">
        <i class="fas fa-save" />&nbsp; Guardar
      </button>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../../shared/modals/CModal.vue";

export default {
  name: "c-modal-toggle-psicotropico",
  components: { CModal },
  props: {
    title: { type: String, default: "Editar psicotrópico" },
    boo_modal: Boolean,
    item: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      localValue: 0,
    };
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) this.mtdInit();
    },
  },
  methods: {
    mtdInit() {
      this.localValue = parseInt(this.item.psicotropico) === 1 ? 1 : 0;
    },
    mtdSave() {
      this.$emit("mtdSaveToggle", {
        product_detail_id: this.item.id,
        psicotropico: this.localValue,
      });
    },
    mtdClose() {
      this.$emit("mtdCloseModalToggle");
    },
  },
};
</script>